// Translations
import { useTrans } from "@/lib/i18n"

/**
 * PreviewBar
 *
 * Fixed purple bar naming the preview environment, same as Horizon's preview bar.
 * Only mounted on preview builds (see main.tsx), so production never renders or translates it.
 * Its height is exposed as --preview-bar-height (src/styles/index.css) so the page and its sticky elements sit below it.
 */
export function PreviewBar({ name }: { name: string }) {
	const t = useTrans("common")

	return (
		<div
			id="preview-bar"
			className="fixed inset-x-0 top-0 z-[60] h-7 truncate bg-[#5b21b6] px-4 py-1 text-center text-sm font-bold text-white"
		>
			{t("common:app.preview_bar.title", { name })}
		</div>
	)
}
